export enum VideoPlayerInteraction {
  PLAY = 'Play',
  PAUSE = 'Pause',
  COMPLETE = 'Complete',
}
